<template>
  <div>
    <el-dialog title="详情" :visible.sync="dialogVisible" width="40%" :close-on-click-modal="false" :modal-append-to-body="false">
      <el-descriptions class="margin-top" title="" :column="1" label-position="right">
        <el-descriptions-item label="商品图片">
          <el-image
            style="width: 100px; height: 100px; cursor: pointer"
            :src="ratedList.productPic"
            @click="onPreview"
          />
        </el-descriptions-item>
        <el-descriptions-item label="订单编号">{{ ratedList.orderSn }}</el-descriptions-item>
        <el-descriptions-item label="商品名称">{{ ratedList.productName }}</el-descriptions-item>
        <el-descriptions-item label="属性">{{ ratedList.productAttr | formatProductAttr }}</el-descriptions-item>
        <!-- <el-descriptions-item label="状态">{{ ratedList.status | formatStatus }}</el-descriptions-item> -->
        <el-descriptions-item label="评价星级">
          <el-rate v-model="ratedList.star" show-text :texts="texts" disabled />
        </el-descriptions-item>
        <el-descriptions-item label="评价内容">{{ ratedList.content | formatContent }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleImage" :modal-append-to-body="false">
      <img width="80%" :src="ratedList.productPic">
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'EvaluateEdit',
  filters: {
    formatStatus(type) {
      if (type === 0) {
        return '待审核'
      } else if (type === 1) {
        return '审核通过'
      } else if (type === 2) {
        return '审核驳回'
      }
    },
    formatTime(time) {
      const dateString = time
      const date = new Date(dateString)
      const year = date.getFullYear()
      let month = date.getMonth() + 1 // getMonth() 返回的月份从0开始，所以需要+1
      let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      let second = date.getSeconds()

      // 为了保持两位数，当小于10的时候，前面补0
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      hour = hour < 10 ? '0' + hour : hour
      minute = minute < 10 ? '0' + minute : minute
      second = second < 10 ? '0' + second : second
      return `${year}-${month}-${day}  ${hour}:${minute}:${second}`
    },
    formatProductAttr(value) {
      if (value == null) {
        return ''
      } else {
        const attr = JSON.parse(value)
        let result = ''
        for (let i = 0; i < attr.length; i++) {
          result += attr[i].key
          result += ':'
          result += attr[i].value
          result += ';'
        }
        return result
      }
    },
    formatContent(value) {
      if (value === null || value === '' || value === undefined) {
        return '无'
      } else {
        return value
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      ratedList: {},
      dialogVisibleImage: false,
      texts: ['非常不满意', '不满意', '一般', '满意', '非常满意']
    }
  },
  created() {
    window.scrollTo(0, 0)
  },
  mounted() {},
  methods: {
    show(row) {
      this.ratedList = row
      this.dialogVisible = true
    },
    onPreview() {
      this.dialogVisibleImage = true
    }
  }
}
</script>

<style>
.margin-top{
  margin-left: 50px;
}
/* 修改标签元素的样式 */
.el-descriptions__item .el-descriptions__label {
  text-align: right !important;
}
.el-descriptions-item__label:not(.is-bordered-label) {
    margin-right: 25px;
    width: 120px;
    text-align: right;
    float: right;
    display: inline-block;
}
</style>
